<script setup lang="ts">
import Wrapper                              from "../../Layouts/Wrapper.vue";
import Container                            from "../../CommonComponents/Container.vue";
import Section                              from "../../CommonComponents/Section.vue";
import SectionTitle                         from "../../CommonComponents/SectionTitle.vue";
import __                                   from "../../../Utils/tranlation";
import { useForm, usePage }                 from "@inertiajs/vue3";
import { onMounted, useTemplateRef }        from "vue";
import { handleValidateForms, removeClass } from "../../../Utils/helpers";
import AlertDanger                          from "../../CommonComponents/AlertDanger.vue";
import AlertSuccess                         from "../../CommonComponents/AlertSuccess.vue";
import FormErrorText                        from "../../CommonComponents/FormErrorText.vue";

type TypeProps = {
    success? : string,
    title? : string,
    id : string,
    name : string,
    url : string,
};

const props = defineProps<TypeProps>();

const form = useForm({
    _token: usePage().props.csrf_token,
    url: (props.url.length ? props.url : null),
    error_qr_code: null,
    name: (props.name.length ? props.name : null),
});

const formEl = useTemplateRef('formEl');

const reactiveForm = (e : Event) : void => {
    if ((e.target as HTMLFormElement).checkValidity()) {
        form.patch(
            route('dynamic-qr-code.update', {id: props.id}), {
                onSuccess: () => {
                    form.clearErrors();
                    removeClass('was-validated', formEl.value);
                    // @ts-ignore
                    form.reset([
                        'name', 'url'
                    ]);
                }
            }
        );
    }
};

onMounted(() => {
    handleValidateForms();
});
</script>

<template>
    <Wrapper :title>
        <template #main>
            <Section>
                <Container>
                    <SectionTitle class="mb-6">
                        {{ __('text_title') }}
                    </SectionTitle>

                    <template v-for="error in form.errors">
                        <AlertDanger :error></AlertDanger>
                    </template>

                    <AlertSuccess :success></AlertSuccess>

                    <form @submit.prevent="reactiveForm($event)"
                          ref="formEl"
                          class="needs-validation flex flex-col gap-y-6 max-w-sm mx-auto"
                          novalidate>

                        <div>
                            <label for="name"
                                   class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {{ __('text_name') }}
                            </label>

                            <input type="text" id="name" v-model="form.name"
                                   class="bg-gray-50 border border-gray-300 text-gray-900
                                           text-sm rounded-lg focus:ring-blue-500
                                           focus:border-blue-500 block w-full p-2.5
                                           dark:bg-gray-700 dark:border-gray-600
                                           dark:placeholder-gray-400 dark:text-white
                                           dark:focus:ring-blue-500 dark:focus:border-blue-500"/>
                        </div>

                        <div>
                            <label for="url"
                                   class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {{ __('text_url') }}
                            </label>

                            <input type="text" id="url" v-model="form.url"
                                   class="bg-gray-50 border border-gray-300 text-gray-900
                                           text-sm rounded-lg focus:ring-blue-500
                                           focus:border-blue-500 block w-full p-2.5
                                           dark:bg-gray-700 dark:border-gray-600
                                           dark:placeholder-gray-400 dark:text-white
                                           dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                   placeholder="http(s)://example.com"
                                   required/>

                            <FormErrorText :error="__('error_url')"></FormErrorText>
                        </div>

                        <button type="submit"
                                :disabled="form.processing"
                                class="text-white bg-blue-700
                                       hover:bg-blue-800 focus:ring-4 focus:outline-none
                                       focus:ring-blue-300 font-medium rounded-lg
                                       text-lg w-full sm:w-auto px-5 py-2.5 text-center
                                       dark:bg-blue-600 dark:hover:bg-blue-700
                                       dark:focus:ring-blue-800">
                            {{ __('text_submit') }}
                        </button>
                    </form>
                </Container>
            </Section>
        </template>
    </Wrapper>
</template>

<style scoped>

</style>
